import Nullstack from 'nullstack';
export default function IconMathXDivideY({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-math-x-divide-y",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 3l6 6"
  }), "   ", Nullstack.element("path", {
    d: "M9 9l6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M9 15l3 4.5"
  }), "   ", Nullstack.element("path", {
    d: "M15 15l-4.5 7"
  }), "   ", Nullstack.element("path", {
    d: "M5 12h14"
  }), " ");
}